
export const flowsbasic = {

  workflowaction: {
    service: {
      name: 'workflowaction',
      title: 'Workflow Action',
    }
  },

  workflowpriority: {
    service: {
      name: 'workflowpriority',
      title: 'Workflow Priority',
    }
  },

};
